import React, { Component, CSSProperties } from "react";
import "./Timer.css";

export default class Timer extends Component<{
	duration: number;
	active: boolean;
	style?: CSSProperties;
	paused: boolean;
}> {
	render() {
		return this.props.active ? (
			<div className="timer-container">
				<div
					className="timer"
					style={{
						animationDuration: this.props.duration + "s",
						animationPlayState: this.props.paused ? "paused" : "running",
					}}
				></div>
			</div>
		) : (
			""
		);
	}
}
